import { UPLOAD_SOURCES } from '@cld/upload-widget-common';
import { asAbsolute } from 'root/routes/utils';
import CameraTab from '../index';

export default [
  {
    path: asAbsolute(UPLOAD_SOURCES.CAMERA),
    component: CameraTab,
  },
];
